import React from 'react';
import PropTypes from 'prop-types';

const CNAME = 'RTB__item';

const ReasonsToBelieveItem = ({ text, icon }) => (
  <li className={`${CNAME} col-xs-12 col-sm-6 col-md-3`} >
    <div className={`${CNAME}__icon`}>{icon}</div>
    <div className={`${CNAME}__text`}>
      <span
      // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  </li>
);

ReasonsToBelieveItem.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired
};


export default ReasonsToBelieveItem;